import { useCurrentSearchParams } from "hooks/useCurrentSearchParams"
import { defaultQueryParamsBikeLabelOrder } from "../constants"
import { BikeLabelOrderIndexStepEnum } from "../types"

export const useGetStepQueryParams = (): `${BikeLabelOrderIndexStepEnum}` => {
	const [{ step }] = useCurrentSearchParams(defaultQueryParamsBikeLabelOrder)
	return step
}
